<template>
  <v-container class="page">
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-row v-if="alertState">
      <v-col cols="12">
        <v-alert
          outlined
          text
          :type="alertType"
        >
          {{ alertText }}
        </v-alert>
      </v-col>
    </v-row>
    <v-card v-show="showForm">
      <v-card-title style="font-size:20px;color:#00ACDC;">
        {{
          formTitle
        }}
      </v-card-title>
      <!-- <v-alert v-model="isEmpty" type="error" dismissible>
        Please complete all fields
      </v-alert> -->
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="6"
          >
            <v-form ref="form">
              <v-select
                label="Company"
                outlined
                hide-details
                v-model="selectedClientId"
                class="my-4"
                :items="allCompanies"
                :item-text="(dt) => `${dt.tradingname}`"
                :item-value="(dt) => `${dt.clientid}`"
                :rules="selectRules"
                v-if="$store.state.type == 3"
                required
              />
              <v-text-field
                type="text"
                class="my-4"
                outlined
                hide-details
                v-model="geofenceName"
                label="Geofence Name"
                required
                :rules="[(v) => !!v || 'Geofence name is required']"
              />
              <v-select
                label="Geofence Type"
                outlined
                hide-details
                v-model="selectedGeoType"
                class="my-4"
                :items="geoGroupList"
                :item-text="(dt) => `${dt.name}`"
                :item-value="(dt) => `${dt.Id}`"
                :rules="selectRules"
                required
              />
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="6"
                    sm="6"
                  >
                    <v-btn
                      @click="cancelCreate()"
                      type="submit"
                      outlined
                      block
                      color="error"
                    >
                      CANCEL
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="6"
                    sm="6"
                  >
                    <v-btn
                      @click="onSubmit()"
                      type="submit"
                      block
                      color="success"
                      to="/geofence"
                      :loading="loadingUpdate"
                      :disabled="loadingUpdate"
                    >
                      SAVE
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-form>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="6"
          >
            <div>
              <!-- <v-text-field
                type="text"
                class="my-4"
                outlined
                hide-details
                clearable
                @click:clear="onClearTextLocation"
                label="Find Location"
                append-icon="mdi-map-marker"
                v-on:keyup.enter="onFindLocation"
                v-model="textLocation"
              /> -->
              <!-- <v-list
                v-if="resultLocations.length > 0"
                style="max-height: 200px; margin-bottom: 16px;"
                class="overflow-y-auto"
                dense
              >
                <v-list-item-group color="primary">
                  <v-list-item
                    v-for="(item, i) in resultLocations"
                    :key="i"
                    @click="onClickLocation(item)"
                  >
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list> -->
              <v-autocomplete
                v-model="destination.selected"
                :items="destination.locations"
                :loading="destination.loading"
                :no-filter="true"
                :search-input.sync="destination.search"
                hide-selected
                hide-no-data
                hide-details
                clearable
                item-text="address"
                item-value="address"
                label="Find Location"
                outlined
                class="my-4"
                return-object
                :rules="selectRules"
                :class="
                  destinationRequired
                    ? 'error--text v-input--has-state'
                    : ''
                "
                append-icon=""
              />
              <GmapMap
                ref="mymap"
                style="width: 100; height: 400px"
                :options="gmapOption"
                :center="center"
                :zoom="zoom"
              >
                <GmapPolygon
                  v-if="paths.length > 0"
                  :paths="paths"
                  :editable="true"
                  @rightclick="handleClickForDelete"
                  @paths_changed="onChangePathsPoly($event)"
                  ref="polygon"
                />
                <!-- <GmapMarker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m.position"
                /> -->
                <GmapMarker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m.position"
                />
              </GmapMap>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="deldialog"
      persistent
      max-width="500"
    >
      <v-card
        dark
        color="red"
      >
        <v-card-title>
          <span>
            <v-icon>mdi-alert-circle</v-icon> Are you sure to want to delete
            this geofence?
          </span>
        </v-card-title>
        <v-card-text>
          You will delete this geofence permanently.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="deldialog = false"
          >
            No
          </v-btn>
          <v-btn
            text
            @click="submitDeleteGeo()"
            :loading="loadingUpdate"
            :disabled="loadingUpdate"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card
      width="100%"
      style="border-radius:10px;"
      class="pa-3"
      v-show="!showForm && !overlay"
    >
      <v-card-title class="title font-weight-light">
        Geofence Management
        <v-spacer />
        <v-text-field
          v-model="searchData"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        />
      </v-card-title>
      <v-card-text>
        <div class="d-flex">
          <v-btn
            color="#00ACDC"
            dark
            class="mb-2 ml-auto"
            @click="handleCreateNew"
          >
            CREATE NEW GEOFENCE
          </v-btn>
        </div>
        <v-data-table
          v-show="!showForm"
          :headers="headers"
          :items="geofencesListTable"
          class="font-weight-light"
          :loading="loadingGeo"
          loading-text="Loading..."
          :footer-props="footerProps"
          @update:options="updatePaging"
          :server-items-length="geofenceTotal"
          :options.sync="paginationOptions"
        >
          <template #[`item.no`]=" { item }">
            {{ ((paginationOptions.page - 1) * paginationOptions.itemsPerPage) + geofencesListTable.indexOf(item) + 1 }}
          </template>
          <template #[`item.show`]="{ item }">
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  color="blue"
                  @click="showPopupMap(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon small>
                    mdi-eye
                  </v-icon>
                </v-btn>
              </template>
              <span>Show Map</span>
            </v-tooltip>
          </template>
          <template #[`item.action`]="{ item }">
            <v-icon
              small
              class="mr-2"
              color="green"
              @click="editGeofence(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              small
              color="red"
              @click="deleteGeofence(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <template #no-data>
            Geofence not available, please create a new geofence
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="popupMapShow"
      width="700"
      @click:outside="popupMapShow = false"
    >
      <v-card
        style="border-radius:10px;"
        class="pa-10"
        outlined
      >
        <v-card-title>
          <v-icon
            color="#00ACDC"
            size="26"
          >
            mdi-map-marker
          </v-icon> {{ popupMap.name }}
        </v-card-title>
        <v-card-text class="my-0">
          <GmapMap
            :style="popupMap.style"
            ref="popupMap"
            :center="popupMap.center"
            :zoom="popupMap.zoom"
            :options="popupMap.options"
          >
            <GmapPolygon
              v-if="popupPaths.length > 0"
              :paths="popupPaths"
              ref="popupPolygon"
            />
          </GmapMap>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import throttle from "lodash/throttle";
import orderBy from "lodash/orderBy";
import round from "lodash/round";
import merge from "lodash/merge";
import isEmpty from "lodash/isEmpty";
import isNull from "lodash/isNull";
import { gmapApi } from "vue2-google-maps"
const qs = require("qs");


export default {
  data() {
    return {
      userType: this.$store.state.type,
      token: this.$store.state.token,
      clientId: this.$store.state.clientid,
      selectRules: [(v) => !!v || "Item is required"],
      center: null,
      defaultCenter: {
        lat: -23.8511901,
        lng: 131.2038283,
      },
      zoom: 4,
      gmapOption: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
      },
      popupMapShow: false,
      popupMap: {
        name: "",
        longitude: "",
        latitude: "",
        style: "width: 200; height: 500px",
        center: {
          lat: -23.8511901,
          lng: 131.2038283,
        },
        options: {
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: true,
          disableDefaultUi: false,
        },
      },
      popupPaths: [],
      paths: [],
      mvcPaths: null,
      polygonGeojson: "",
      textLocation: "",
      resultLocations: [],
      markers: [],
      geofenceName: "",
      selectedClientId: "",
      selectedGeoType: "",
      allCompanies: [],
      geoGroupList: [],
      alertText: "",
      alertState: false,
      alertType: "success",
      showForm: false,
      headers: [],
      geofencesListTable: [],
      deldialog: false,
      deleteTarget: null,
      editIdTarget: null,
      loadingGeo: false,
      loadingUpdate: false,
      loader: null,
      searchData: "",
      searchDataTimeout: null,
      destinationRequired: false,
      destination: {
        search: null,
        timeout: null,
        loading: false,
        locations: [],
        selected: {},
      },
      overlay: false,
      geofenceTotal: 0,
      footerProps: {
        itemsPerPageOptions: [2, 3, 5, 10, 20, 50, 100, 200, 500]
      },
      paginationOptions: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: []
      },
    };
  },
  watch: {
    "destination.search"() {
      clearTimeout(this.destination.timeout);
      if (this.destination.selected) {
        if (this.destination.search == this.destination.selected.address)
          return;
      }
      if (!this.destination.search) {
        this.destination.selected = "";
        this.destination.locations = [];
        this.destination.loading = false;
        return;
      }
      if (!isNull(this.destination.search)) {
        this.destinationRequired = false;
      }
      this.destination.timeout = setTimeout(() => {
        this.handleSearchDestination(this.destination.search, this);
      }, 2e3);
    },
    "destination.selected"(value) {
      const geo = value;
      const distance = 50;
      const coefficient = distance * 0.0000089;

      if (!geo) return;
      this.paths = [];
      // if (geo.type == "sd") {
        // const lat2 = parseFloat(this.map.oriPosition.lat);
      const lat = parseFloat(geo.latitude);
      const lng = parseFloat(geo.longitude);
      this.center = {
        lat: Number(lat),
        lng: lng,
      };
      this.markers = [
        {
          position: {
            lat: lat,
            lng: lng,
          },
        },
      ];
      this.zoom = 18;

      let coordinatesGeojson = [
        [(lng-coefficient), (lat-coefficient) ],
        [(lng+coefficient), (lat-coefficient) ],
        [(lng+coefficient), (lat+coefficient) ],
        [(lng-coefficient), (lat+coefficient) ],
        [(lng-coefficient), (lat-coefficient) ],
      ];

      let coordinates = [
        { lng: (lng-coefficient), lat: (lat-coefficient) },
        { lng: (lng+coefficient), lat: (lat-coefficient) },
        { lng: (lng+coefficient), lat: (lat+coefficient) },
        { lng: (lng-coefficient), lat: (lat+coefficient) },
        { lng: (lng-coefficient), lat: (lat-coefficient) },
      ];

      this.paths.push(coordinates);

      this.polygonGeojson = {
        type: "Polygon",
        coordinates: [coordinatesGeojson]
      };
    },
    polygonPaths: throttle(function(paths) {
      if (paths) {
        this.paths = paths;
        this.polygonGeojson = {
          type: "Polygon",
          coordinates: this.paths.map((path) =>
            this.closeLoop(path.map(({ lat, lng }) => [lng, lat]))
          ),
        };
      }
    }, 1e3),
    selectedClientId(clientid) {
      this.loadGeofenceGroup(clientid);
    },
    deldialog(show) {
      if (!show) {
        this.deleteTarget = null;
      }
    },
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
    overlay(val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 2e3)
    },
    searchData(query) {
      clearTimeout(this.searchDataTimeout)
      this.searchDataTimeout = setTimeout(() => {
        this.paginationOptions.page     = 1;
        this.paginationOptions.sortBy   = [];
        this.paginationOptions.sortDesc = [];
        this.getGeofenceTotal();
        this.getGeofences();
      }, 1e3)
    }
  },
  computed: {
    google: gmapApi,
    polygonPaths() {
      if (!this.mvcPaths) return null;

      let paths = [];
      for (let i = 0; i < this.mvcPaths.getLength(); i++) {
        let path = [];
        for (let j = 0; j < this.mvcPaths.getAt(i).getLength(); j++) {
          let point = this.mvcPaths.getAt(i).getAt(j);
          path.push({ lat: point.lat(), lng: point.lng() });
        }
        paths.push(path);
      }
      return paths;
    },
    formTitle() {
      return isEmpty(this.editIdTarget)
        ? "Create New Geofence"
        : "Edit Geofence";
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.mymap.$mapPromise.then(() => {
        /*eslint-disable */
        const drawingManager = new google.maps.drawing.DrawingManager({
          drawingControl: true,
          drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_LEFT,
            drawingModes: [google.maps.drawing.OverlayType.POLYGON],
          },
          polygonOptions: {
            fillColor: "#FFFFFF",
            fillOpacity: 0.7,
            strokeColor: "#2196F3",
            strokeWeight: 4,
            editable: true,
          },
        });
        drawingManager.setMap(this.$refs.mymap.$mapObject);

        google.maps.event.addListener(
          drawingManager,
          "overlaycomplete",
          (event) => {
            let paths = event.overlay.getPaths().getArray();
            event.overlay.setMap(null);
            drawingManager.setDrawingMode(null);

            this.paths = paths;
            this.mvcPaths = event.overlay.getPaths();
          }
        );
        /*eslint-enable */
      });
    });
  },
  methods: {
    runApi(method, adtPost) {
      const qs = require("qs");
      const postData = merge(adtPost, {
        token: this.token,
      });
      return this.$http.post(
        `${process.env.VUE_APP_API_URL}/${method}`,
        qs.stringify(postData)
      );
    },
    showPopupMap(item) {
      this.popupMap.name = item.name;

      const { poly } = item;
      const polyArr = poly.split(",");
      let paths = [];

      let i = 0;
      let minLat = null;
      let maxLat = null;
      let minLng = null;
      let maxLng = null;
      const bounds = new this.google.maps.LatLngBounds();
      while (i < polyArr.length) {
        const polygon = {
          lng: parseFloat(polyArr[i]),
          lat: parseFloat(polyArr[i + 1]),
        };
        const { lat, lng } = polygon;
        bounds.extend(new this.google.maps.LatLng(lat, lng));
        if (minLat === null || minLat > lat) minLat = lat;
        if (maxLat === null || maxLat < lat) maxLat = lat;
        if (minLng === null || minLng > lng) minLng = lng;
        if (maxLng === null || maxLng < lng) maxLng = lng;
        paths.push(polygon);
        i += 2;
      }

      // const [lng, lat] = center_coordinates;
      setTimeout(() => {
        this.$refs.popupMap.fitBounds(bounds);
      }, 300);
      /* this.markers = [
        {
          position: {
            lat: Number(lat),
            lng: Number(lng),
          },
        },
      ]; */
      this.popupPaths = [paths];
      this.popupMapShow = true;
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        const geoData = this.polygonGeojson;
        const isEdit = !isEmpty(this.editIdTarget);
        const action = isEdit ? "update_geofence" : "create_geofence";

        if (isEmpty(geoData)) {
          this.setAlertState("error", "Please create Geofence Polygon on Map.", true);
          return;
        }

        const polygon = geoData.coordinates[0];
        const poly = polygon.map((p) => p.map(n => round(n, 6)).join(','))
          .join(',');

        let minLat = null;
        let maxLat = null;
        let minLng = null;
        let maxLng = null;
        polygon.forEach(([lng, lat]) => {
          if (minLat === null || minLat > lat) minLat = lat;
          if (maxLat === null || maxLat < lat) maxLat = lat;
          if (minLng === null || minLng > lng) minLng = lng;
          if (maxLng === null || maxLng < lng) maxLng = lng;
        });

        const [l, b, r, t] = [round(minLng, 6), round(minLat, 6), round(maxLng, 6), round(maxLat, 6)];

        const dataGenerate = {
          clientid: this.selectedClientId,
          group_id: this.selectedGeoType,
          name: this.geofenceName,
          bottom: b,
          top: t,
          left: l,
          right: r,
          poly,
          metadata: {
            center_coordinates: [(r + l) / 2, (t + b) / 2],
            // area_size: parseFloat(geom.getArea().toFixed(2)),
          },
        };

        if (isEdit) {
          dataGenerate["id"] = this.editIdTarget;
        }

        this.loadingUpdate = true;
        this.loader = this.loadingUpdate;

        this.runApi(action, dataGenerate).then((resp) => {
          const { data } = resp;
          if (data.status_text == "OK") {
            this.loadingUpdate = false;
            this.loader = this.loadingUpdate;
            this.$swal({
              icon: 'success',
              title: data.data.message,
            })
            // this.setAlertState("success", "Geofence successfully saved.", true);
            this.reset();
            this.showForm = false;
          } else {
            this.loadingUpdate = false;
            this.loader = this.loadingUpdate;
            this.$swal({
              icon: 'error',
              title: data.data.message,
            })
            // this.setAlertState("error", "Geofence failed to save.", true);
          }
          this.getGeofenceTotal();
          this.getGeofences();
        });
      }
    },
    onClearTextLocation() {
      this.textLocation = "";
      this.resultLocations = [];
      this.markers = [];
      this.center = this.defaultCenter;
    },
    handleSearchDestination: async (q, vm) => {
      if (vm.destination.loading) return;

      vm.destination.loading = true;

      let baseUrl = process.env.VUE_APP_CARPOOLING_URL.replace('carpooling', '');
      baseUrl = baseUrl.replace('_dev', '');
      const filterAu = process.env.VUE_APP_WEB != "fleetpooling";
      const queryAddress = qs.stringify({ query: q, key: '70hrLH@SZ&pa2g', filter_au: filterAu });
      const url = `${baseUrl}index.php/public_api/search_address_carpool?${queryAddress}`
      return vm.$http
        .get(url)
        .then(response => {
          if (response) {
            const { data } = response;
            let addressFormatted = [];
            let streetFormatted = [];

            if (data.hasOwnProperty("address")) {
              addressFormatted = data.address.map(p => {
                if (p.hasOwnProperty("id")) {
                  let streetType =
                    p.street_type === "Street" ? "St" : p.street_type;
                  let number =
                    p.number_last !== null
                      ? `${p.number_first}-${p.number_last}`
                      : p.number_first;

                  p.address = `${number} ${p.street_name} ${streetType}, ${
                    p.locality_name
                  }, ${p.state_name}, ${p.postcode}`;
                }
                return p;
              });
            }

            if (data.hasOwnProperty("street")) {
              streetFormatted = data.street.map(s => {
                if (s.hasOwnProperty("id")) {
                  s.address = `${s.street_name}, ${s.locality_name}, ${
                    s.state_name
                  }, ${s.postcode}`;
                }
                return s;
              });
            }

            if (Array.isArray(data)) {
              addressFormatted = data.map(p => ({
                longitude: p.lng,
                latitude: p.lat,
                address: p.address
              }));
            }

            vm.destination.locations = [
              ...addressFormatted,
              ...streetFormatted
            ];
          }
        })
        .then(() => (vm.destination.loading = false));
    },
    // handleSearchDestination: async (query, vm) => {
    //   if (vm.destination.loading) return;

    //   vm.destination.loading = true;

    //   const token = vm.token;
    //   const queryAddress = qs.stringify({ token, query });
    //   const url = `${process.env.VUE_APP_API_URL}/search_address`;
    //   vm.$http
    //     .post(url, queryAddress)
    //     .then((response) => {
    //       if (response) {
    //         const {
    //           data: { data: address },
    //         } = response;
    //         const addressFormatted = address.map((a) => {
    //           if (a.hasOwnProperty("Id")) a.address = a.name;
    //           return a;
    //         });
    //         vm.destination.locations = addressFormatted;
    //       }
    //     })
    //     .finally(() => (vm.destination.loading = false));
    // },
    handleFocusDestination() {
      if (this.destination.search === "" || this.destination.search === null) {
        this.destination.locations = [];
      }
    },
    onFindLocation() {
      this.$store.dispatch('API_CALL', {
          $method: 'search_address',
          $postData: {
            query: this.textLocation,
          },
        })
        .then((res) => {
          let results = res.data.data || [];
          if (results.length) {
            results = results.map((location) => {
              return {
                text: location.address,
                icon: "mdi-map-marker",
                positions: { lat: location.lat, lng: location.lng },
              };
            });
          } else {
            results = [
              {
                text: "Not found any location",
                icon: "mdi-map-marker",
              },
            ];
          }
          this.resultLocations = orderBy(results, ["text"]);
        });
    },
    onClickLocation(locationData) {
      if (locationData.hasOwnProperty("positions")) {
        let { lat, lng } = locationData.positions;
        this.center = {
          lat: Number(lat),
          lng: Number(lng),
        };
        this.markers = [
          {
            position: {
              lat: Number(lat),
              lng: Number(lng),
            },
          },
        ];
        this.zoom = 18;
      }
    },
    getAllCompany() {
      return this.runApi("get_all_company").then((resp) => {
        const { data } = resp.data;
        const companies = data.filter((dt) => dt.active == 1);
        this.allCompanies = orderBy(companies, ["tradingname"]);
        this.selectedClientId = this.clientId;
      });
    },
    loadGeofenceGroup(clientid) {
      this.runApi("get_geofence_group_carpool", {
        clientid,
      }).then((resp) => {
        const { data } = resp.data;
        this.geoGroupList = data[clientid];
      });
    },
    setAlertState(type, text, state = false) {
      this.alertType = type;
      this.alertText = text;
      this.alertState = state;
      setTimeout(() => {
        this.alertState = false;
      }, 5e3);
    },
    handleClickForDelete($event) {
      if ($event.vertex) {
        this.$refs.polygon.$polygonObject
          .getPaths()
          .getAt($event.path)
          .removeAt($event.vertex);
      }
    },
    cancelCreate() {
      this.showForm = false;
      this.reset();
      // this.getGeofences();
    },
    reset() {
      this.$refs.mymap.$mapObject.data.setDrawingMode(null);
      this.center = this.defaultCenter;
      this.geofenceName = "";
      this.markers = [];
      this.paths = [];
      this.mvcPaths = null;
      this.zoom = 4;
      this.deleteTarget = null;
      this.editIdTarget = null;
      this.textLocation = "";
      this.resultLocations = [];
      this.destination.selected = {};
      this.polygonGeojson = "";
    },
    onChangePathsPoly(mvcPaths) {
      this.mvcPaths = mvcPaths;
    },
    closeLoop(path) {
      return path.concat(path.slice(0, 1));
    },
    getGeofenceTotal() {
      this.token = this.$store.state.token;
      this.clientid = this.$store.state.clientid;
      this.$store.dispatch('API_CALL', {
        $method: 'get_geofence_total',
        $postData: {
          clientid: this.$store.state.clientid,
          query: this.searchData
        },
      }).then((response) => {
        this.geofenceTotal = parseInt(response.data.data.total);
      })
    },
    getGeofences() {
      this.loadingGeo = true;

      const { page, itemsPerPage, sortBy, sortDesc } = this.paginationOptions;
      const sort_by  = sortBy.length ? sortBy[0] : 'name';
      const sort_dir = sortDesc.length ? (sortDesc[0] ? 'desc' : 'asc') : 'asc';
      const offset   = (page - 1) * itemsPerPage;

      const isAdmin = this.userType == 3;
      const postData = {
        type: this.userType,
        limit: itemsPerPage,
        offset,
        sort_by,
        sort_dir,
        query: this.searchData
      };

      if (!isAdmin) {
        postData["clientid"] = this.clientId;
      }

      return this.runApi("get_all_geofence", postData).then((resp) => {
        this.loadingGeo = false;
        this.geofencesListTable = resp.data.data;
        this.getGeofenceTz(resp.data.data[0].Id);
      });
    },
    getGeofenceTz(id) {
      this.clientid = this.$store.state.clientid;
      this.$store.dispatch('API_CALL', {
        $method: 'get_tz_depot',
        $postData: {
          clientid: this.$store.state.clientid,
          geofence_id: id,
        },
      }).then((response) => {
        console.log(response);
      })
    },
    getCompanyDetail(clientid) {
      return this.allCompanies.find((dt) => dt.clientid == clientid);
    },
    editGeofence(data) {
      const { clientid, name, group_id, Id, poly, metadata } = data;
      const { center_coordinates } = metadata;
      const polyArr = poly.split(",");
      let paths = [];

      let i = 0;
      let minLat = null;
      let maxLat = null;
      let minLng = null;
      let maxLng = null;
      const bounds = new this.google.maps.LatLngBounds();
      while (i < polyArr.length) {
        const polygon = {
          lng: parseFloat(polyArr[i]),
          lat: parseFloat(polyArr[i + 1]),
        };
        const { lat, lng } = polygon;
        bounds.extend(new this.google.maps.LatLng(lat, lng));
        if (minLat === null || minLat > lat) minLat = lat;
        if (maxLat === null || maxLat < lat) maxLat = lat;
        if (minLng === null || minLng > lng) minLng = lng;
        if (maxLng === null || maxLng < lng) maxLng = lng;
        paths.push(polygon);
        i += 2;
      }

      const [lng, lat] = center_coordinates;
      setTimeout(() => {
        this.$refs.mymap.fitBounds(bounds);
      }, 300);
      this.markers = [
        {
          position: {
            lat: Number(lat),
            lng: Number(lng),
          },
        },
      ];
      this.paths = [paths];
      this.selectedClientId = clientid;
      this.geofenceName = name;
      this.selectedGeoType = group_id;
      this.editIdTarget = Id;

      this.polygonGeojson = {
        type: "Polygon",
        coordinates: this.paths.map((path) =>
          this.closeLoop(path.map(({ lat, lng }) => [lng, lat]))
        ),
      };

      this.showForm = true;
    },
    deleteGeofence(data) {
      this.deldialog = true;
      this.deleteTarget = data;
    },
    submitDeleteGeo() {
      const targetId = this.deleteTarget.Id;
      this.loadingUpdate = true;
      this.loader = this.loadingUpdate;
      this.runApi("delete_geofence", { id: targetId }).then((resp) => {
        const { data } = resp;
        this.deldialog = false;
        if (data.status_text == "OK") {
          this.loadingUpdate = false;
          this.loader = this.loadingUpdate;
          // this.setAlertState("success", "Geofence successfully deleted.", true);
          this.$swal({
            icon: 'success',
            title: data.data.message,
          })
        } else {
          this.loadingUpdate = false;
          this.loader = this.loadingUpdate;
          // this.setAlertState("error", "Geofence failed to delete.", true);
          this.$swal({
            icon: 'success',
            title: data.data.message,
          })
        }
        Promise.all([
          this.getGeofenceTotal(),
          this.getGeofences(),
        ]).then(() => {
          // Total data ada, tapi di page ini kosong
          if (this.geofenceTotal > 0 && this.geofencesListTable.length === 0) {
            // reset page ke page 1
            this.paginationOptions.page = 1
            // load ulang data
            this.getGeofenceTotal();
            this.getGeofences();
          }
        })
        
      });
    },
    handleCreateNew() {
      this.center = this.defaultCenter;
      this.zoom = 4;
      this.paths = [];
      this.selectedGeoType = null;
      this.$refs.form.resetValidation();
      this.showForm = true;
    },
    updatePaging(options) {
      this.getGeofenceTotal();
      this.paginationOptions = options;
      this.getGeofences();
    },
  },
  created() {
    this.center = this.defaultCenter;
    if (this.userType == 3) {
      this.getAllCompany().then(() => {
        this.getGeofenceTotal();
        this.getGeofences();
      });
      this.headers = [
        { text: "No", value: "no", sortable: false },
        { text: "Company", value: "tradingname" },
        { text: "Geofence Name", value: "name" },
        { text: "Type", value: "type" },
        { text: "Show", value: "show" },
        { text: "Actions", value: "action", sortable: false },
      ];
    } else {
      this.getGeofenceTotal();
      this.getGeofences();
      this.selectedClientId = this.clientId;
      this.headers = [
        { text: "No", value: "no", sortable: false },
        { text: "Geofence Name", value: "name" },
        { text: "Type", value: "type" },
        { text: "Show", value: "show" },
        { text: "Actions", value: "action", sortable: false },
      ];
    }
    this.overlay = true;
  },
};
</script>
